export default __webpack_public_path__ + "static/media/feather-eye.a3f50d50.svg";